/* eslint-disable no-undef */
const useGoogleRecaptchaTokenizer = () => {
  const WEBSITE_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY

  const appendScript = () => {
    const recaptchaScript = document.querySelector(`script[src="https://www.google.com/recaptcha/api.js?render=${WEBSITE_KEY}"]`)

    if (!recaptchaScript && 'undefined' === typeof grecaptcha) {
      const scriptTag = document.createElement('script')
      scriptTag.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${WEBSITE_KEY}`)
      document.body.appendChild(scriptTag)
    }
  }

  const invokeChallenge = () => {
    return new Promise(resolve => {
      grecaptcha.ready(function () {
        grecaptcha.execute(WEBSITE_KEY, { action: 'submit' }).then(token => {
          resolve(token)
        })
      })
    })
  }

  return [invokeChallenge, appendScript]
}

export default useGoogleRecaptchaTokenizer